export default "__VITE_ASSET__bRaf1pHn__"